import React from 'react';

type RenderComponentProps = Props & {handleChange: (val: string) => void};

type Props = {
    render: React.FC<RenderComponentProps>;
    onChange: (val: string) => void;
};

export const TextValidationControl = (props: Props) => {
    const handleInputChange = val => {
        props.onChange && props.onChange(val);
    };
    const RenderComponent = props.render;

    return <RenderComponent {...props} handleChange={handleInputChange} />;
};
